<template>
    <div class="frequency_wrapper">
        <div class="frequency_blue_border">
            <h3 class="mailing_title mailing_text_color__blue mailing_title_position">Периодчиность рассылки</h3>
            <h5 v-if="mailingStore.mailingPeriods.length <= 0" class="frequency_h5">Нет добавленных периодов рассылки</h5>

            <div v-if="mailingStore.mailingPeriods.length" class="frequency_items_wrapper">
                <template v-for="(day) in getMainDataAsTempData().selectedDays">
                    <div class="frequency_text frequency_padding_r frequency_padding_l py-10 frequency_border_bottom flex">
                        <p class="flex">
                            {{ day }}
                        </p>
                    </div>
                    <div class="frequency_text py-10 frequency_border_bottom">
                        <p style="display: inline" v-for="(time, index) in getMainDataAsTempData().selectedTimes[day]">
                            {{ time }}:00
                            <span v-if="index !== getMainDataAsTempData().selectedTimes[day].length - 1">
                                ,
                            </span>
                        </p>
                    </div>
                </template>
            </div>
            <new-button
                class="btn_plus"
                style="align-self: flex-end; padding: 10px 15px; margin: 10px 5px;"
                :buttonColoring="'blue'"
                @click="editingFrequency"
            >
                {{ buttonFrequency }}
            </new-button>
        </div>

        <new-modal class="flex-col w-fit gap-20"
            v-if="ModalStore.modalSelectFrequencyMailing.modalVisibility"
            @close="closeModal"
            :modalTitle="'Укажите периодичность рассылки'"
            ref="modalFrequency"
        >
            <div class="mailing_period_wrapper">
                <div>
                    <new-button class="mailing_highlighting_button" @click="fillAllDays" button-padding="5px 15px">
                        {{ titleFillButton }}
                    </new-button>
                </div>
                <div
                    class="mailing_picker"
                    :class="{ 'overflow_active': maxLengthOfSelectedTimes > 10}"
                >
                    <div>
                        <h4 class="mailing_title_hidden mailing_text_color__darkBlue mailing_period_text_title" style="margin-bottom: 34px">Дни:</h4>
                        <h4 class="mailing_title_hidden mailing_text_color__darkBlue mailing_period_text_title">Время:</h4>
                    </div>
                    <div class="mailing_picker_days">
                        <div
                            class="mailing_day_wrapper"
                            v-for="(day, index) in Object.keys(selectedTimes)"
                            :key="index"
                            @mouseover="showButton(day, index, 'add')"
                            @mouseleave="hideButton(day, index, 'add')"
                        >
                            <div
                                class="mailing_period_text cursor_pointer mailing_day_unselected"
                                :key="index"
                                :class="{ 'mailing_day_selected': selectedDays.some(item => item === day)}"
                                @click="() => selectDay(day)"
                                style="margin-bottom: 25px"
                            >
                                {{ day }}
                            </div>
                            <div
                                class="mailing_inputs_container"
                                v-if="selectedDays.includes(day)"
                                v-for="(time, i) in selectedTimes[day]"
                                @mouseover="showButton(day, i, 'delete')"
                                @mouseleave="hideButton(day, i, 'delete')"
                            >
                                <input
                                    class="mailing_text_color__white mailing_period_text_title mailing_input_time"
                                    id="hour_input"
                                    name="hour_input"
                                    type="number"
                                    @input="limitInputLengthHours(day, i)"
                                    v-model="selectedTimes[day][i]"
                                    placeholder="-"
                                    min="0"
                                    max="23"
                                >
                                <span
                                    class="mailing_text_color__darkBlue mailing_period_text_title"
                                >
                                    :00
                                </span>
                                <button
                                    class="btn-reset btn_plus mailing_button_delete"
                                    style="margin-left: -2px"
                                    @click.stop="deleteTime(day, i)"
                                    v-if="deleteTimeButtonVisibility[day][i] && selectedTimes[day].length > 1"
                                >
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.500015" width="15" height="15" rx="7.5" fill="white" stroke="#D21317"/>
                                        <line x1="5" y1="8.00002" x2="11" y2="8.00002" stroke="#D21317" stroke-width="2"/>
                                    </svg>
                                </button>
                            </div>
                            <button
                                class="btn-reset btn_plus add_time_button"
                                v-if="selectedTimes[day].length > 0"
                                :class="{ 'add_time_button_visible': addTimeButtonVisibility[index]}"
                                @click="addTime(day)"
                                @mouseover="showButton(day, index, 'addTitle')"
                                @mouseleave="hideButton(day, index, 'addTitle')"
                            >
                                <svg width="18" height="18" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.83527 9.10995L1.83232 10.8859C1.83155 11.3464 2.22556 11.7404 2.71884 11.7725L8.77038 11.7624L8.76032 17.814C8.75956 18.2744 9.15357 18.6684 9.64684 18.7005L11.3571 18.6976C11.8175 18.6969 12.2128 18.3015 12.2465 17.8082L12.2566 11.7566L18.3081 11.7466C18.7686 11.7458 19.1639 11.3505 19.1976 10.8571L19.2004 9.14689C19.2012 8.68644 18.8072 8.29243 18.3139 8.26036L12.2295 8.23758L12.2396 2.18605C12.2404 1.7256 11.8464 1.33159 11.3531 1.29952L9.64286 1.30237C9.18241 1.30313 8.78709 1.69845 8.75338 2.19184L8.74333 8.24337L2.6918 8.25343C2.23135 8.25419 1.83603 8.64951 1.83527 9.10995Z" fill="#174A8B"/>
                                </svg>
                                <div
                                    class="add_time_button_title"
                                    v-if="addTimeButtonTitleVisibility[index] && maxLengthOfSelectedTimes <= 10"
                                >
                                    Добавить время
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="!validation" class="frequency_warning_text">
                Не выбран день недели для рассылки
            </p>
            <p v-if="titleFillButton === 'Выделить все *'" class="frequency_info_text">
                * Копирует расписание понедельника на все невыбранные дни.
            </p>
            <div class="frequency_modal_btnWrapper">
                <new-button
                    style="padding: 10px 20px;"
                    :buttonColoring="'blue'"
                    @click="closeModal(true)"
                    v-if="validation"
                >
                    Сохранить
                </new-button>
            </div>
        </new-modal>
    </div>
</template>

<script>
import newModal from "@/shared/newModal.vue";
import newButton from "@/shared/newButton.vue";
import { useModalStore } from '@/stores/ModalStore';
import { useMailingStore } from "@/stores/MailingStore";
import { generateUniqueId } from '@/utils/generateUniqueId.js';

export default {
    name: "FrequencyMailing",
    components: {
        newModal,
        newButton
    },

    mounted() {
        this.validation = true;
        this.buttonFrequency = this.mailingStore.mailingPeriods.length <= 0 ? 'Создать' : 'Редактировать';
    },

    setup() {
        const ModalStore = useModalStore();
        const mailingStore = useMailingStore();
        return {
            ModalStore,
            mailingStore
        }
    },

    data: function () {
        return {
            // Временные данные
            selectedDays: ['Пн'],
            selectedTimes: {
                'Пн': ['12'],
                'Вт': [],
                'Ср': [],
                'Чт': [],
                'Пт': [],
                'Сб': [],
                'Вс': [],
            },

            validation: true,
            buttonFrequency: '',
            maxLengthOfSelectedTimes: 1,

            // Отображение кнопочек при наведении
            addTimeButtonVisibility: [],
            addTimeButtonTitleVisibility: [],
            deleteTimeButtonVisibility: {
                'Пн': [],
                'Вт': [],
                'Ср': [],
                'Чт': [],
                'Пт': [],
                'Сб': [],
                'Вс': [],
            },

            titleFillButton: 'Выделить все *',
            selectedTimesBuffer: {
                'Пн': [],
                'Вт': [],
                'Ср': [],
                'Чт': [],
                'Пт': [],
                'Сб': [],
                'Вс': [],
            },
            daysOfWeek: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
        }
    },

    watch: {
        selectedDays: function (newVal, _) {
            if (newVal.length === 7) {
                this.updateTitleFillButton('Снять выделение');
            }

            if (newVal.length < 7) {
                this.updateTitleFillButton('Выделить все *');
            }
        },
    },

    created() {
        this.$watch(() => this.mailingStore.mailingPeriods, () => {
            this.buttonFrequency = this.mailingStore.mailingPeriods.length <= 0 ? 'Создать' : 'Редактировать';
        });
    },

    methods: {
        addTime(day) {
            const selectedTimesLength =  this.selectedTimes[day].length;
            if (selectedTimesLength > 0) {
                const nextNumber = Number(this.selectedTimes[day][selectedTimesLength- 1]) + 1;
                this.selectedTimes[day].push(nextNumber >= 23 ? '0' : nextNumber.toString())
            } else {
                this.selectedTimes[day].push('12');
            }


            let acc = 0;
            for (let times of Object.values(this.selectedTimes)) {
                if (times.length > acc) acc = times.length;
            }
            this.maxLengthOfSelectedTimes = acc;
        },

        deleteTime(day, index) {
            this.selectedTimes[day].splice(index, 1);

            let acc = 0;
            for (let times of Object.values(this.selectedTimes)) {
                if (times.length > acc) acc = times.length;
            }
            this.maxLengthOfSelectedTimes = acc;
        },

        getMainDataAsTempData() {
            if (this.mailingStore.mailingPeriods.length > 0) {
                const tempData = {
                    selectedDays: [],
                    selectedTimes: {
                        'Пн': [],
                        'Вт': [],
                        'Ср': [],
                        'Чт': [],
                        'Пт': [],
                        'Сб': [],
                        'Вс': [],
                    }
                };

                // Собираем this.selectedTimes
                for (let period of this.mailingStore.mailingPeriods) {
                    for (let day of period.selectedDays) {
                        if (!tempData.selectedTimes[day].includes(period.hour))
                        tempData.selectedTimes[day].push(period.hour);
                    }
                }

                // Собираем this.selectedDays
                for (let day in tempData.selectedTimes)
                    if (tempData.selectedTimes[day].length > 0)
                        tempData.selectedDays.push(day);

                // Сортировка
                for (let day in tempData.selectedTimes) {
                    tempData.selectedTimes[day] = Array.from(new Set(tempData.selectedTimes[day]
                        .filter(time => time !== ''))).sort((a, b) => Number(a) - Number(b));

                    if (tempData.selectedDays.includes(day) && !tempData.selectedTimes[day].length)
                        tempData.selectedDays.splice(tempData.selectedDays.indexOf(day), 1);
                }

                return tempData;
            }
            else {
                return {
                    selectedDays: ['Пн'],
                    selectedTimes: {
                        'Пн': ['12'],
                        'Вт': [],
                        'Ср': [],
                        'Чт': [],
                        'Пт': [],
                        'Сб': [],
                        'Вс': [],
                    }
                };
            }
        },

        getTempDataAsMainData() {
            const mainData = [];

            // Определяем длину mailingPeriods
            let allTimes = [];
            for (let day in this.selectedTimes)
                if (day.length > 0)
                    allTimes = Array.from(new Set(allTimes.concat(this.selectedTimes[day])));

            // Заполняем mailingPeriods по времени
            for (let time of allTimes)
                mainData.push({
                    hour: time,
                    minutes: '00',
                    selectedDays: [],
                    id: generateUniqueId()
                });

            for (let day of this.selectedDays)
                for (let item = 0; item < mainData.length; item++)
                    if (this.selectedTimes[day].includes(mainData[item].hour))
                        mainData[item].selectedDays.push(day);

            return mainData;
        },

        showButton(day, index, button) {
            switch (button) {
            case 'add':
                this.$set(this.addTimeButtonVisibility, index, true);
                break;
            case 'addTitle':
                this.$set(this.addTimeButtonTitleVisibility, index, true);
                break;
            case 'delete':
                this.$set(this.deleteTimeButtonVisibility, day, {});
                this.$set(this.deleteTimeButtonVisibility[day], index, true);
                break;
            }
        },

        hideButton(day, index, button) {
            switch (button) {
            case 'add':
                this.$set(this.addTimeButtonVisibility, index, false);
                break;
            case 'addTitle':
                this.$set(this.addTimeButtonTitleVisibility, index, false);
                break;
            case 'delete':
                this.$set(this.deleteTimeButtonVisibility[day], index, false);
                break;
            }
        },

        editingFrequency() {
            if (this.mailingStore.mailingPeriods.length > 0)
                this.setTempData();

            this.ModalStore.switchingVisibility(this.ModalStore.modalSelectFrequencyMailing);
        },

        setMainData() {
            // Сортировка
            for (let day in this.selectedTimes) {
                this.selectedTimes[day] = Array.from(new Set(this.selectedTimes[day]
                    .filter(time => time !== ''))).sort((a, b) => Number(a) - Number(b));

                if (this.selectedDays.includes(day) && !this.selectedTimes[day].length)
                    this.selectedDays.splice(this.selectedDays.indexOf(day), 1);
            }

            if (this.selectedDays.length === 0) this.mailingStore.mailingPeriods = [];
            else this.mailingStore.mailingPeriods = this.getTempDataAsMainData();
        },

        setTempData() {
            const tempDataForFrequency = this.getMainDataAsTempData();

            this.selectedDays = tempDataForFrequency.selectedDays.slice(0);
            this.selectedTimes = {...tempDataForFrequency.selectedTimes};

            for (let day in tempDataForFrequency.selectedTimes) {
                this.selectedTimes[day] = new Array();
                for (let time of tempDataForFrequency.selectedTimes[day]) {
                    this.selectedTimes[day].push(time);
                }
            }
        },

        closeModal(withSave = false) {
            withSave ? this.setMainData() : this.setTempData();
            this.validation = true;
            this.ModalStore.switchingVisibility(this.ModalStore.modalSelectFrequencyMailing);
        },

        limitInputLengthHours(day, index) {
            if (this.selectedTimes[day][index].length > 2) {
                this.selectedTimes[day][index] = this.selectedTimes[day][index].slice(0, 2);
            }
            this.selectedTimes[day][index] = String(Math.min(this.selectedTimes[day][index], 23));
        },

        validationDays() {
            this.validation = this.selectedDays.length > 0;
        },

        selectDay(day, isFill=false) {
            const weekArray = Object.keys(this.selectedTimes);

            if (!isFill) {
                // Выключить день
                if (this.selectedDays.includes(day)) {
                    this.selectedDays = this.selectedDays.filter((item) => item !== day);
                    this.selectedTimesBuffer[day] = [...this.selectedTimes[day]];
                    this.selectedTimes[day] = [];
                }
                // Включить день
                else {
                    this.selectedDays = this.selectedDays.concat(day).sort((a, b) =>
                        weekArray.indexOf(a) - weekArray.indexOf(b));

                    this.selectedTimes[day] = [...this.selectedTimesBuffer[day]];

                    if (this.selectedTimes[day].length === 0) this.selectedTimes[day].push('12');
                }

                this.validation = this.selectedDays.length > 0;
            } else {

                if (this.selectedDays.includes(day)) {
                    this.selectedDays = this.selectedDays.filter((item) => item !== day);
                    this.selectedTimes[day] = [];
                }

                else {
                    this.selectedDays = this.selectedDays.concat(day).sort((a, b) =>
                        weekArray.indexOf(a) - weekArray.indexOf(b));

                    if (this.selectedTimes[day].length === 0) {
                        this.selectedTimes[day] = this.selectedTimes['Пн'].length === 0 ? ['12'] : [...this.selectedTimes['Пн']]
                    };
                }

                this.validationDays();
            }
        },

        fillAllDays() {
            let diffDaysOfWeek = [];

            if (this.selectedDays.length === 0) {
                this.selectedDays = [...this.daysOfWeek];
                this.daysOfWeek.forEach((day) => {
                    this.selectedTimes[day] = ['12'];
                });

                this.validationDays();
                return;
            }

            if (this.titleFillButton === 'Выделить все *') {
                diffDaysOfWeek = this.daysOfWeek.reduce((acc, day) => {
                    if (!this.selectedDays.includes(day)) acc.push(day);
                    return acc;
                }, []);
            } else {
                diffDaysOfWeek = [...this.daysOfWeek];
            }

            diffDaysOfWeek.forEach((day) => {this.selectDay(day, true)})
        },

        updateTitleFillButton(text) {
            this.titleFillButton = text;
        },
    },
}
</script>

<style scoped>
    .overflow_active {
        max-height: 540px;
        overflow-y: auto;
        overflow-x: hidden;
        width: 820px;
    }

    .add_time_button {
        position: relative;

        visibility: hidden;
    }

    .add_time_button_visible {
        visibility: visible;
    }

    .add_time_button_title {
        position: absolute;
        top: 100%;
        width: 110px;

        color: #fff;
        background-color: #9ABCD6;
        padding: 7px 10px 5px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, .25);
    }

    .frequency_wrapper {
        display: flex;
        width: fit-content;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .frequency_modal_btnWrapper {
        display: flex;
        width: 200px;
        justify-content: flex-end;
        align-self: end;
    }

    .frequency_info_text {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: var(--color-blue);
    }

    .frequency_warning_text {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: var(--color-red);
    }

    .frequency_blue_border {
        display: flex;
        flex-direction: column;
        border: solid 3px #174A8B;
        position: relative;
        padding: 35px 5px 0px 5px;
        width: 450px;
        justify-content: space-between;
        height: fit-content;
        gap: 30px;
        flex-shrink: 0;
    }

    .frequency_blue_border_modal {
        border: solid 3px #174A8B;
        position: relative;
        padding: 35px 15px 0px 15px;
    }

    .frequency_h5 {
        margin-top: 15px;
        font-size: 18px;
        font-weight: 400;
        text-align: center;
    }

    /* TODO выделить в отдельные компоненты кнопки-иконки */

    .btn_plus {
        display: flex;
        width: fit-content;
        align-self: center;
    }

    .btn_plus:hover > svg > path {
        fill: var(--color-green);
        transition: fill 0.3s ease-out;
    }

    .btn_plus > svg > path {
        fill: var(--color-blue);
        transition: fill 0.3s ease-out;
    }

    .btn_edit {
        display: flex;
        height: fit-content;
        flex-shrink: 0;
    }

    .btn_edit:hover > svg > path {
        fill: var(--color-green);
        transition: fill 0.3s ease-out;
    }

    .btn_edit > svg > path {
        fill: var(--color-blue);
        transition: fill 0.3s ease-out;
    }

    .frequency_items_wrapper {
        display: grid;
        margin-top: 15px;
        grid-template-columns: 0fr 1fr;
    }

    .frequency_text {
        font-size: 16px;
        font-weight: 400;
    }

    .frequency_border_bottom {
        border-bottom: 1px dashed var(--color-gray);
    }

    .frequency_padding_l {
        padding-left: 15px;
    }

    .frequency_padding_r {
        padding-right: 15px;
    }

    .mailing_highlighting_button {
        font-size: 16px;
        font-weight: 400;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;
    }

    .mailing_button_delete {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 500px) {
        .frequency_blue_border {
            width: 310px;
        }
    }

    @media (max-width: 850px) {
        .mailing_title_hidden {
            display: none;
        }

        .overflow_active {
            width: fit-content ;
            max-height: 380px;
            overflow-y: auto;
            overflow-x: auto;
        }
    }
</style>
